import React from 'react';
import {Button} from 'react-bootstrap';
import {HiOutlinePhone} from 'react-icons/hi';
import {FaWhatsapp} from 'react-icons/fa';
import {useLanguage, t} from '../../i18n';

export default function ListingContactActions({requiresAccess, canCall, canWhatsApp, onContact, onCall, onWhatsApp}) {
  useLanguage();
  return <div className="bb-listing-details__contact-actions">
    {requiresAccess ? <Button className="w-100 bb-listing-details__contact-btn" onClick={onContact}>
      <HiOutlinePhone className="me-2" />{t('Contact Owner')}
    </Button> : <>
      {canCall && <Button className="w-100 bb-listing-details__contact-btn" onClick={onCall}>
        <HiOutlinePhone className="me-2" />{t('Call Owner')}
      </Button>}
      {canWhatsApp && <Button variant="success" className="w-100 bb-listing-details__whatsapp-btn" onClick={onWhatsApp}>
        <FaWhatsapp className="me-2" />{t('WhatsApp Owner')}
      </Button>}
    </>}
  </div>;
}
